import React, { useContext, useState, useEffect } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { PostAPI } from "api/post";
import Card from "components/Card/Card.jsx";
import { isEmpty } from "components/Login/validator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import SimpleReactValidator from 'simple-react-validator';
import { MDBRow, MDBCol } from 'mdbreact';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import 'react-sortable-tree/style.css';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import BeatLoader from "react-spinners/BeatLoader";
const cookies = new Cookies();

const Role = props => {
  
  const initialValue = [{displayValue: "Please Select", value: ''}];
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  let [url, setUrl] = useState();
  let [searchInputValue, setsearchInputValue] = useState();
  let [viewPermission, setViewPermission] = useState(false);
  let[array,setArray] = useState([])
  const [showFilter, setshowFilter] = useState(false);
  const [showCSearch, setshowCSearch] = useState(false);
  let [loadTableData, setloadTableData] = useState(true);
  let [page, setpage] = useState(1);
  let [values, setValues] = useState();
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [dropDownApi, setDropDownApi] = useState();
  let [isLoader, setIsLoader] = useState(false);
  let headerData = {
     start_from: 0,
     customer_id:cookies.get('customer_id'),
     user_id:cookies.get('user_id'),
  }
  let dynamicParameters = {
    customer_id:cookies.get('customer_id'),
    user_id:cookies.get('user_id'),
    userLocation_id:cookies.get('userLocation_id'),
    userRole_name:cookies.get('userRole_name')
 }

  let [formValues, setformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();


  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  const formElementsArray = [];
  for (let key in ModalformValues) {
    formElementsArray.push({
      id: key,
      config: ModalformValues[key]
    });
  }

  const inputChangedHandler = (event, inputIdentifier) => {
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  }

  async function instantValuesUpdateFilterBox() {
    let url = pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ cookies.get('userRole_name') + '&start_from='+ headerData.start_from
    let getdrpdwnresponse = await FetchAPI(url);
    const getdrpdwnresponseJson = await getdrpdwnresponse.json();
    const updateForm = {
        ...formValues
    }
    const dropVal = {
        ...getdrpdwnresponseJson.data
    }
    let obj;
    obj = Object.keys(getdrpdwnresponseJson.data).forEach((el) => {
        if( Object.keys(el, updateForm)){
          if(!isEmpty(dropVal[el])){
              if(updateForm[el].elementType == 'select'){
                  updateForm[el].elementConfig.options = dropVal[el];
                  updateForm[el].elementConfig.options.splice(0, 0, ...initialValue)
              }
              else if(updateForm[el].elementType == 'multiselect') {
                  updateForm[el].elementConfig.options = dropVal[el];
              }   
          }
          else
          {
              if(updateForm[el].elementType == 'select' )
              updateForm[el].elementConfig.options = initialValue;
              if(updateForm[el].elementType == 'multiselect' )
              updateForm[el].elementConfig.options = null;
          }
        }
        setformValues(updateForm);
      })
    }

  async function exportPdf(e, id) {
    e.preventDefault();
    FetchAPI(`${pageLayoutData[0].exportEndPoint}?delivery_id=${id}&customer_id=${cookies.get("customer_id")}`)
.then(responseJson => responseJson.json())
.then((response) => {
     const url = response.data.data
            const link = document.createElement('a');
            link.target = '_self';
            link.href = url;
            link.setAttribute('download', url);
            link.click();
})
  }

  async function filteredExport(data) {
    let arr = Object.values(data);
    let valueNull = arr.some((el) => el.value !== null)
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null && pageLayoutData[1].title1 !== "Location Types") {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert.toString();;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else if(data[formElementIdentifier].elementType === 'select'){
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
      }
      else{
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
      }
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
      if(valueNull === false) {
         return swal("Choose any field to export","Poducts Log","warning")
      }else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET'){
        setIsLoader(true);
        responseData = await PostAPI(getURL, newObj);
        window.location.href = responseData?.data.data.Location
      }else{
        responseData = await FetchAPI(getURL, newObj);
      }
    if(responseData.status == 200){
      setIsLoader(false);
      swal('Your request is under process',
          'Shortly, you will receive an email with downloadable link','success')
          for (let formElementIdentifier in data) {
              if(data[formElementIdentifier].elementType === 'multiselect' || data[formElementIdentifier].elementConfig.type === 'date') {
                  data[formElementIdentifier].value = null
              }
            }
      }
      else{
        swal('Something went wrong','Please download again','error')
      }
  }

  
  useEffect(() => {
    (async () => {
      (pageLayoutData[0].filterStatus == true && setformValues(pageLayoutData[0].formValues));
      if (pageLayoutData != 'undefined') {
        if(pageLayoutData[0].filterStatusDefault === true)
        setshowFilter(true);
        else
        setshowFilter(false);
        setloadTableData(false);
        setUrl(pageLayoutData[0].exportEndPoint)
        setsearchInputValue();
        setshowCSearch(false);
        setpage(1);
        let totalParams;
        let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
        }
        totalParams = {...totalParams, ...dynamicParameters}
        if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && pageLayoutData[1].subComponentsItems?.apiEndPoint) {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            for (let i = 0; i < responseDataJson.data.data.length; i++) {
              if (responseDataJson.data.data[i].childData.length === 0) {
                array.push(responseDataJson.data.data[i].name);
              }
            }
            setViewPermission(responseDataJson.data.viewPermission)
            setformValues(pageLayoutData[0].formValues);
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('Oops..! Something went wrong.');
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('Oops..! Something went wrong.');
          }
        }
        setloadTableData(true);
      }

    })()
  }, [pageLayoutData])

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

  async function filteredExport2(data) {
    setValues(data)
  }

  async function clearFilteredData(event) {
      setshowFilter(!showFilter);
  }

  const openFilter = () => {
    setshowFilter(!showFilter);
    let URL= pageLayoutData[0].hasOwnProperty('filterEndPoint') ? 
    pageLayoutData[0].filterEndPoint: 'not found'
    let totalParams={};
    if(pageLayoutData[0].extraParametersDropdown !== null) {
      const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
      totalParams = {...totalParams, ...extraParametersDropdown}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(URL !== 'not found') {
    let paramsConverted = new URLSearchParams(totalParams);
    URL = (`${URL}?${paramsConverted.toString()}`);
    setDropDownApi(URL);
    }else 
    setDropDownApi('not found')
  }
  
  async function exportFile(e,name) {
    e.preventDefault();
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email')
    }
    const getURL = (pageLayoutData[0].exportApiEndPoint) ? pageLayoutData[0].exportApiEndPoint 
    : (name === pageLayoutData[0].exportButtonName1) ? pageLayoutData[0].exportApiEndPoint1 
    : (name === pageLayoutData[0].exportButtonName2) ?  pageLayoutData[0].exportApiEndPoint2
    : (name === pageLayoutData[0].exportButtonName3) ?  pageLayoutData[0].exportApiEndPoint3
    : 'not found';
    let newgetURL,getresponse,dataObject;
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in values) {
        if(values[formElementIdentifier].elementType === 'multiselect') {
          if((values[formElementIdentifier].value)) {
            let arrayConvert = [];
            values[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert.toString();
          }
          else
            searchFormData[formElementIdentifier] = null;
          }
        else
          searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
        getresponse = await PostAPI(getURL, dataObject);
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
      }
    }
    if(getresponse.status == 200){
        swal('Your request is under process',
        'Shortly, you will receive an email with downloadable link','success')
    }
    else{
      swal('Something went wrong','Please download again','error')
    }
  }

 
  return (
    (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 18) ?
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                title={(pageLayoutData[1].title1) ? pageLayoutData[1].title1 : ''}
                title2={( pageLayoutData[1].title2) ? pageLayoutData[1].title2 : ''}
                content={
                        <div>
                          <MDBRow>
                          <MDBCol md="12" className="mb-12">
                          <div style={{float: 'right'}}>
                          {(pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" key="Filter" submit={() => openFilter()} BName="Filter" /> : ''}
                          </div>
                          </MDBCol>
                          </MDBRow>
                          {showFilter ?
                            <FilterBox
                             key="FilterBox" 
                             title={pageLayoutData[1].title2}
                             setformValues = { setformValues }
                             formValue={formValues} 
                             filteredExport = {filteredExport}
                             filteredExport2 = {filteredExport2}
                             change={inputChangedHandler} 
                             clearClick={clearFilteredData}
                             validate={validator}
                             exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                             dropDownApi = {pageLayoutData[0].hasOwnProperty('filterEndPoint') ? pageLayoutData[0].filterEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ cookies.get('userRole_name') + '&start_from='+ headerData.start_from : 'not found' } 
                             />
                            : ''}
                            {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                        </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
      : <div className="content">
      <Grid fluid>
        <div className="text-center" style={{ margin:"80px" }}><LoadingSpinner /></div>
      </Grid>
    </div>
  );
}

export default Role;